// extracted by mini-css-extract-plugin
export var container = "kontakt-module--container--2DJzc";
export var contactSection = "kontakt-module--contactSection--1H4-2";
export var sectionTitle = "kontakt-module--sectionTitle--22tBS";
export var contactDetail = "kontakt-module--contactDetail--inuke";
export var companyName = "kontakt-module--companyName--26RtC";
export var ic = "kontakt-module--ic--3Hk2O";
export var note = "kontakt-module--note--Ppkhc";
export var logo = "kontakt-module--logo--N2eoV";